const actions = {
  GET_SHIFT_LOAD: 'GET_SHIFT_LOAD',
  GET_SHIFT_SUCCESS: 'GET_SHIFT_SUCCESS',
  GET_SHIFT_ERROR: 'GET_SHIFT_ERROR',

  getLoad: () => {
    return { type: actions.GET_SHIFT_LOAD };
  },
  getSuccess: (shifts) => {
    return { type: actions.GET_SHIFT_SUCCESS, shifts };
  },
  getErr: (err) => {
    return { type: actions.GET_SHIFT_ERROR, err };
  },

  ADD_SHIFT_BEGIN: 'ADD_SHIFT_BEGIN',
  ADD_SHIFT_SUCCESS: 'ADD_SHIFT_SUCCESS',
  ADD_SHIFT_ERROR: 'ADD_SHIFT_ERROR',

  addShiftBegin: () => {
    return { type: actions.ADD_SHIFT_BEGIN };
  },

  addShiftSuccess: (shifts) => {
    return { type: actions.ADD_SHIFT_SUCCESS, shifts };
  },

  addShiftErr: (err) => {
    return { type: actions.ADD_SHIFT_ERROR, err };
  },

  GET_SHIFT_SINGLE__LOAD: 'GET_SHIFT_SINGLE__LOAD',
  GET_SHIFT_SINGLE__SUCCESS: 'GET_SHIFT_SINGLE__SUCCESS',
  GET_SHIFT_SINGLE__ERROR: 'GET_SHIFT_SINGLE__ERROR',
  GET_SHIFT_CLEAR_OBJECT: 'GET_SHIFT_CLEAR_OBJECT',

  getSingleLoad: () => {
    return { type: actions.GET_SHIFT_SINGLE__LOAD };
  },
  getSingleSuccess: (shifts) => {
    return { type: actions.GET_SHIFT_SINGLE__SUCCESS, shifts };
  },
  getSingleErr: (err) => {
    return { type: actions.GET_SHIFT_SINGLE__ERROR, err };
  },

  clearObject: () => {
    return { type: actions.GET_SHIFT_CLEAR_OBJECT };
  },
};

export default actions;
